import { useContext } from 'react';
import { PastSearchesContext } from '@containers/WorkspaceGlobalSearch/Context';

export default function usePastSearches() {
  const context = useContext(PastSearchesContext);
  return context;
}

export { usePastSearches };